import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import i18n from "i18next";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import {
  DeleteRegular,
  MailDismissRegular,
  PersonDeleteRegular,
} from "@fluentui/react-icons";

interface IDialogRemoveMemberProps {
  currentUser?: IAppUserDto;
  userIsInvited?: boolean;
  userIsMember?: boolean;
  onDeleteMember(): void;
  onRemoveInvite(): void;
}

function DialogRemoveMember(props: IDialogRemoveMemberProps) {
  return (
    <Dialog>
      <DialogTrigger action="open">
        <Button
          appearance="transparent"
          icon={
            props.userIsMember ? (
              <PersonDeleteRegular />
            ) : (
              <MailDismissRegular />
            )
          }
        >
          {props.userIsMember && i18n.t<string>("removeMember")}
          {props.userIsInvited && i18n.t<string>("removeInvite")}
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            {props.userIsMember && i18n.t<string>("removeMember")}
            {props.userIsInvited && i18n.t<string>("removeInvite")}
          </DialogTitle>
          <DialogContent>
            {props.userIsMember && i18n.t<string>("removeMemberText")}
            {props.userIsInvited && i18n.t<string>("removeInvite")}
          </DialogContent>
          <DialogActions>
            <DialogTrigger action="close">
              <Button
                appearance="primary"
                onClick={() => {
                  if (props.userIsMember) {
                    props.onDeleteMember();
                  }
                  if (props.userIsInvited) {
                    props.onRemoveInvite();
                  }
                }}
              >
                {props.userIsMember && i18n.t<string>("removeMember")}
                {props.userIsInvited && i18n.t<string>("removeInvite")}
              </Button>
            </DialogTrigger>
            <DialogTrigger action="close">
              <Button>{i18n.t<string>("cancel")}</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default DialogRemoveMember;
